:host {
    --uui-chart-title-margin-bottom: var(--uui-extra-large-bottom-margin);
    --uui-chart-subtitle-margin-top: 0.25rem;
}

.chart-title {
    margin: 0;

    &-container {
        margin-bottom: var(--uui-chart-title-margin-bottom);
    }

    +.chart-sub-title {
        margin-top: var(--uui-chart-subtitle-margin-top);
    }
}

.chart-sub-title {
    margin: 0;
}